export const AGENCY_ROLE = "agency";
export const INTERPRETER_ROLE = "interpreter";
export const REQUESTER_ROLE = "client";

export const LOGIN_PATH = "/login";
export const AGENCY_PATH = `/${AGENCY_ROLE}`;
export const INTERPRETER_PATH = `/${INTERPRETER_ROLE}`;
export const REQUESTER_PATH = `/requester`;

export const DEFAULT_LOGO_URL = "/assets/logo";
export const DEFAULT_PAGES = {
  [AGENCY_ROLE]: AGENCY_PATH,
  [INTERPRETER_ROLE]: INTERPRETER_PATH,
  [REQUESTER_ROLE]: REQUESTER_PATH,
};
